export const isMacUser = () => {
    const platform = navigator.platform || navigator.userAgentData?.platform;
    return platform && platform.indexOf('Mac') > -1;
};
